import { render, staticRenderFns } from "./methods-id-editor.vue?vue&type=template&id=7a38612c&"
import script from "./methods-id-editor.vue?vue&type=script&lang=ts&"
export * from "./methods-id-editor.vue?vue&type=script&lang=ts&"
import style0 from "./methods-id-editor.vue?vue&type=style&index=0&id=7a38612c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports